import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getUserNotifications} from 'src/openapi/admin/apis/UserInternalNotificationApi';
import {useAppDispatch} from 'src/store/hooks';

export const useGetUsersNotifications = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(getUserNotifications()), [apiDispatch]);

    return useReadOnlyDataHook({
        initValue: [],
        getDispatchAction,
    });
};
